
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Picnicspotnearbhandara() {



  const cardData =
  {
    keyword: ' Picnic Spot Near Bhandara',
    heading:  'Woodland Escape: Picnic Spot Near Bhandara ',
    headingDescription: 'Woodland Escape Resort, one of the best picnic spots near Bhandara, offers a serene and scenic escape surrounded by lush greenery, gentle streams, and forested landscapes — perfect for a relaxing day out with family and friends. Located just a short drive from Bhandara, the resort combines natural beauty with recreational activities, including nature walks, outdoor games, and a swimming pool, making it ideal for all age groups. Guests can unwind on spacious lawns, enjoy delicious meals, and soak in the refreshing ambiance while creating memorable moments. Whether it’s a casual family picnic, a friends’ outing, or a corporate day trip, Woodland Escape Resort near Bhandara ensures a perfect blend of fun, relaxation, and nature’s charm.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
{
"name": "Picnic Spot Near Bhandara",
"description": "Discover the perfect picnic spot near Bhandara, offering serene surroundings, lush greenery, and ideal locations for relaxing with friends and family. Enjoy a refreshing day close to nature."
},
{
"name": "Bhandara Top Picnic Places",
"description": "Explore the top picnic destinations in Bhandara featuring scenic landscapes, riversides, and hills. These locations are perfect for a full-day outing with family or friends."
},
{
"name": "Bhandara Family Picnic Spot",
"description": "Plan a family-friendly picnic in Bhandara with spacious areas for kids to play, picnic setups, and safe environments for a memorable day out together."
},
{
"name": "Bhandara Nature Picnic Spot",
"description": "Enjoy the beauty of nature at Bhandara's most serene picnic spots. Perfect for nature walks, photography, and relaxing amidst greenery and fresh air."
},
{
"name": "Affordable Picnic Spot Bhandara",
"description": "Experience an affordable picnic near Bhandara without compromising on comfort and scenic beauty. Ideal for budget-conscious families and groups seeking a peaceful outing."
},
{
"name": "Bhandara Weekend Picnic",
"description": "Make your weekends special with a picnic at Bhandara's top locations. Enjoy leisurely time, games, and outdoor activities in a calm and picturesque environment."
},
{
"name": "Bhandara Riverside Picnic Spot",
"description": "Relax by the riverside at Bhandara picnic spots offering scenic views, cool breezes, and a peaceful environment perfect for families and friends to gather."
},
{
"name": "Bhandara Garden Picnic Spot",
"description": "Spend a day at well-maintained garden picnic spots in Bhandara, ideal for casual outings, photography, and enjoying nature’s tranquility with loved ones."
},
{
"name": "Bhandara Hill Picnic Spot",
"description": "Plan a picnic on the hills near Bhandara for panoramic views, adventure, and refreshing natural surroundings. Great for hiking enthusiasts and family outings."
},
{
"name": "Bhandara Kids Friendly Picnic Spot",
"description": "Take your children to kid-friendly picnic areas in Bhandara with safe play zones, fun activities, and plenty of space for outdoor games and enjoyment."
},
{
"name": "Bhandara Scenic Picnic Spot",
"description": "Capture the beauty of Bhandara with scenic picnic spots featuring natural landscapes, greenery, and ideal settings for photography and relaxation."
},
{
"name": "Bhandara Outdoor Picnic Spot",
"description": "Enjoy outdoor picnic experiences in Bhandara offering fresh air, open spaces, and recreational activities to make your day memorable."
},
{
"name": "Bhandara Picnic Spot Booking",
"description": "Easily book your picnic spot in Bhandara in advance to secure your preferred location, with options for amenities, food arrangements, and guided tours."
},
{
"name": "Bhandara Picnic Tour Packages",
"description": "Choose from curated picnic tour packages in Bhandara that include travel, meals, and access to top scenic spots for a stress-free and enjoyable day out."
},
{
"name": "Bhandara Best Picnic Location",
"description": "Visit the best picnic locations in Bhandara offering picturesque landscapes, rivers, gardens, and hills for an unforgettable day with family and friends."
}
],
"tableData": [
["- Picnic Spot Near Bhandara", "- Bhandara Top Picnic Places"],
["- Bhandara Family Picnic Spot", "- Bhandara Nature Picnic Spot"],
["- Affordable Picnic Spot Bhandara", "- Bhandara Weekend Picnic"],
["- Bhandara Riverside Picnic Spot", "- Bhandara Garden Picnic Spot"],
["- Bhandara Hill Picnic Spot", "- Bhandara Kids Friendly Picnic Spot"],
["- Bhandara Scenic Picnic Spot", "- Bhandara Outdoor Picnic Spot"],
["- Bhandara Picnic Spot Booking", "- Bhandara Picnic Tour Packages"],
["- Bhandara Best Picnic Location", ""]
],
  


whychoose: [
  {
    "WhyChooseheading": "Perfect Picnic Spot Near Bhandara",
    "WhyChoosedescription": "Woodland Escape Resort offers an ideal picnic destination near Bhandara, set amidst dense forest surroundings. The natural environment provides a refreshing escape from city life, making it perfect for a family day out or group outing."
  },
  {
    "WhyChooseheading": "Serene Forest Ambience",
    "WhyChoosedescription": "Surrounded by lush trees and greenery, the resort provides a tranquil setting. Enjoy the calming sights and sounds of nature while having a fun-filled picnic with your loved ones."
  },
  {
    "WhyChooseheading": "Spacious Outdoor Picnic Areas",
    "WhyChoosedescription": "Woodland Escape Resort features wide open spaces, shaded picnic zones, and comfortable seating arrangements. You can relax, play, or enjoy a meal in a scenic and safe environment."
  },
  {
    "WhyChooseheading": "Fun Activities for All Ages",
    "WhyChoosedescription": "Make your picnic more exciting with various outdoor activities like nature walks, trekking, cycling, and games suitable for kids and adults alike. The forest setting adds adventure to every moment."
  },
  {
    "WhyChooseheading": "Family-Friendly Environment",
    "WhyChoosedescription": "Whether it’s a small family outing or a large group picnic, Woodland Escape Resort ensures a safe and enjoyable experience. Spacious grounds and organized areas make it ideal for everyone to spend quality time together."
  },
  {
    "WhyChooseheading": "Delicious Food & Refreshments",
    "WhyChoosedescription": "Enjoy tasty snacks, local dishes, and beverages prepared on-site, perfect for your picnic day. Fresh, wholesome food complements the outdoor experience and keeps everyone energized."
  },
  {
    "WhyChooseheading": "Easily Accessible from Bhandara",
    "WhyChoosedescription": "Located a short drive from Bhandara, Woodland Escape Resort is convenient for a quick day trip. Spend more time enjoying nature and activities, and less time traveling."
  }
]















  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a picnic spot near Bhandara?",
    answer: "Woodland Escape Resort offers a peaceful and scenic environment perfect for a relaxing picnic near Bhandara. Guests can enjoy nature, open lawns, and outdoor activities in a safe and family-friendly setting."
  },
  {
    question: "How far is Woodland Escape Resort from Bhandara city?",
    answer: "The resort is approximately 40–45 km from Bhandara, which takes around 1 to 1.5 hours by car. It’s ideal for a day trip or short outing with family and friends."
  },
  {
    question: "What activities can we enjoy at the resort during a picnic?",
    answer: "Guests can enjoy nature walks, cycling, open-lawn games, and picnic-style relaxation. There are also play areas for children and peaceful spots for adults to unwind."
  },
  {
    question: "Is Woodland Escape Resort suitable for family picnics?",
    answer: "Absolutely! The resort is family-friendly, with safe outdoor spaces, shaded seating areas, and recreational activities that cater to all age groups."
  },
  {
    question: "Does the resort provide food for picnic guests?",
    answer: "Yes! Woodland Escape Resort offers freshly prepared meals, snacks, and beverages. Picnic packages can include lunch and refreshments for a hassle-free experience."
  },
  {
    question: "How can we book a picnic at Woodland Escape Resort near Bhandara?",
    answer: "You can book by calling or WhatsApp messaging our reservations team or visiting the official website. Advance booking is recommended, especially on weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Amit & Family, Bhandara",
    text: "We had a wonderful picnic at Woodland Escape Resort! The surroundings were beautiful, the kids enjoyed the play areas, and the food was excellent. Truly the best picnic spot near Bhandara."
  },
  {
    name: "Miss. Neha & Friends, Bhandara",
    text: "Woodland Escape Resort made our day out unforgettable! The green lawns, outdoor activities, and peaceful atmosphere were perfect for a picnic. Highly recommended!"
  }
];















      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Picnic Spot Near Bhandara",
  "image": "https://woodlandescape.com/assets/images/picnic-spot-near-bhandara.jpg",
  "description": "Enjoy a perfect outing at Woodlandescape Resort — the ideal picnic spot near Bhandara. Perfect for families and friends, with scenic nature views, outdoor activities, and a relaxing weekend getaway.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "498"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/picnic-spot-near-bhandara"
  }
};


  return (
    <div>

<Helmet>
  <title>Picnic Spot Near Bhandara | Scenic Family Outing | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan a fun-filled picnic at Woodlandescape Resort — the perfect picnic spot near Bhandara. Ideal for families and friends, with nature views, outdoor activities, and relaxing weekend trips." 
  />
  <meta 
    name="keywords" 
    content="Picnic Spot Near Bhandara, Bhandara Top Picnic Places, Bhandara Family Picnic Spot, Bhandara Nature Picnic Spot, Affordable Picnic Spot Bhandara, Bhandara Weekend Picnic, Bhandara Riverside Picnic Spot, Bhandara Garden Picnic Spot, Bhandara Hill Picnic Spot, Bhandara Kids Friendly Picnic Spot, Bhandara Scenic Picnic Spot, Bhandara Outdoor Picnic Spot, Bhandara Picnic Spot Booking, Bhandara Picnic Tour Packages, Bhandara Best Picnic Location" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/16.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Picnicspotnearbhandara;